<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card light>
        <v-card-title class="headline grey--text">
            Agregar Jornada
        </v-card-title>
        <v-card-text class="pt-0">
            <v-container fluid>
                <v-layout row wrap ref="form">
                    <v-flex xs12>
                        <v-select
                            :items="roundItems"
                            label="Selecciona tipo de jornada"
                            bottom
                            light
                            color="green"
                            v-model="setType"
                            :rules="rules.required"
                            ref="type"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 v-if="setType == 'extra'">
                        <v-menu
                            lazy
                            :close-on-content-click="true"
                            v-model="showDatePicker"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                            class="green--text"
                            >
                            <v-text-field
                                slot="activator"
                                label="Fecha de inicio de jornada"
                                v-model="data.date"
                                prepend-icon="event"
                                readonly
                                light
                                color="green"
                                ref="date"
                                :rules="rules.required"
                            ></v-text-field>
                            <v-date-picker
                                light
                                class="green--text"
                                v-model="data.date"
                                scrollable
                                actions
                                locale="es-MX">
                                <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="save">OK</v-btn>
                                </v-card-actions>
                                </template>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 v-if="setType == 'extra'">
                        <v-select
                            :items="roundNameItems"
                            label="Selecciona nombre de jornada"
                            bottom
                            light
                            color="green"
                            v-model="extraName"
                            :rules="rules.required"
                            ref="round"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="cancel()">No</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'NewRoundModal',
        props: {
            dialog: { required: true, default: false },
            typesSelected: { required: true, default: [] }
        },
        data() {
            return {
                hasError: false,
                setType: '',
                extraName: '',
                showDatePicker: false,
                rules: {
                    required: [
                        val => {
                            let res = ((String(val) || '').length > 0 && val != null) || 'Este campo es obligatorio'
                            return res
                        }
                    ]
                },
                roundItems: [
                    { value: 'regular', text: 'Jornada normal'},
                    { value: 'extra', text: 'Jornada extra'}
                ],
                data: {
                    date: null,
                    round: null,
                    roundName: null
                }
            }
        },
        watch: {
            setType(type) {
                if(type === 'regular') {
                    this.extraName = ''
                }
            }
        },
        computed: {
            form() {
                return {
                    type: this.setType,
                    date: this.data.date,
                    round: this.extraName
                }
            },
            roundNameItems() {
                let items = [
                    { value: '1/16', text: 'Dieciséisavos'},
                    { value: '1/8', text: 'Octavos'},
                    { value: '1/4', text: 'Cuartos'},
                    { value: 'semi', text: 'Semifinales'},
                    { value: 'final', text: 'Final'}
                ]
                let finalItems = []

                for(let i = 0, x = items.length; i < x; i++) {
                    console.log(this.typesSelected.indexOf(items[i].value))
                    if(this.typesSelected.indexOf(items[i].value) === -1) {
                        finalItems.push(items[i])
                    }
                }

                console.log('Items', finalItems)

                return finalItems
            }
        },
        methods: {
            confirm(btnPressed) {
                this.hasErrors = false

                Object.keys(this.form).forEach(f => {
                    if(this.$refs[f])
                        if(!this.form[f])
                            this.hasErrors = true

                    if(this.$refs[f])
                        this.$refs[f].validate(true)
                })

                if(this.hasErrors) return

                this.data.round = this.setType
                this.data.roundName = this.extraName

                this.$emit('response', {
                    date: this.data.date,
                    round: this.data.round,
                    roundName: this.data.roundName
                })

                this.clearForm()
            },
            cancel() {
                this.clearForm()
                this.$emit('cancel', 'newroundmodal')
            },
            clearForm() {
                this.data = {
                    date: null,
                    round: null,
                    roundName: null
                }
                this.extraName = ''
                this.setType = ''
            }
        }
    }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournament_calendar/NewRoundModal.vue